'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = require('lodash');

var _bdcoreUtilities = require('@bd/bdcore-utilities');

function PlanConstructor(_ref) {
  var builder = _ref.builder,
      plan = _ref.plan;

  var elements = {
    title: {
      content: 'The ' + (0, _lodash.get)(plan, 'metaTags.title', (0, _lodash.get)(plan, 'name', '')) + ' | ' + (0, _lodash.get)(builder, 'name'),
      attrs: {}
    },
    meta: [{
      name: 'description',
      content: (0, _lodash.get)(plan, 'metaTags.description', (0, _lodash.get)(plan, 'description'))
    }, {
      property: 'og:image',
      content: (0, _bdcoreUtilities.buildThumbnailUrl)((0, _lodash.get)(plan, 'elevationPhotos[0].contentUrl'), { width: 1200, height: 1200 })
    }, {
      property: 'og:title',
      content: 'The ' + (0, _lodash.get)(plan, 'metaTags.title', (0, _lodash.get)(plan, 'name', '')) + ' | ' + (0, _lodash.get)(builder, 'name')
    }, {
      property: 'og:description',
      content: (0, _lodash.get)(plan, 'metaTags.description', (0, _lodash.get)(plan, 'description'))
    }]
  };

  return elements;
}

exports.default = PlanConstructor;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-pagehelmet/build/Plan.js
// module id = 1060
// module chunks = 0